(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a2z-mobile-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-a2z-menu]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const summary = [...document.querySelectorAll('header-drawer > details > summary')].find((element) => element.getClientRects().length);
    if (!summary || typeof summary.closest('header-drawer').toggle !== 'function') return;
    event.preventDefault();
    summary.focus({ preventScroll: true });
    summary.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["a2z-snowfall"] && !Shopify.designMode) return;
  try {
    (() => {
    const layer = document.querySelector('.a2z-snowfall');
    if (!layer) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 749px)');
    const populate = () => {
      layer.replaceChildren();
      if (motion.matches) return;
      const fragment = document.createDocumentFragment();
      for (let i = 0; i < (mobile.matches ? 22 : 38); i++) {
        const flake = document.createElement('span');
        flake.className = 'a2z-snowfall__flake';
        flake.style.setProperty('--snow-left', `${Math.random() * 100}%`);
        flake.style.setProperty('--snow-size', `${3 + Math.random() * 5}px`);
        flake.style.setProperty('--snow-opacity', (0.45 + Math.random() * 0.45).toFixed(2));
        flake.style.setProperty('--snow-duration', `${9 + Math.random() * 9}s`);
        flake.style.setProperty('--snow-delay', `${-Math.random() * 18}s`);
        flake.style.setProperty('--snow-drift', `${Math.random() * 70 - 35}px`);
        fragment.append(flake);
      }
      layer.append(fragment);
    };
    const pause = () => layer.toggleAttribute('data-paused', document.hidden);
    populate();
    pause();
    motion.addEventListener('change', populate);
    mobile.addEventListener('change', populate);
    document.addEventListener('visibilitychange', pause);
  })();
  } catch(e) { console.error(e); }
})();

})();
